import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { SharedModule } from '../../_shared/shared.module';

import { SessionService } from '../services/session.service';

@Component({
  selector: '[app-company-selector]',
  template: `
    <a class="cursor dropdown-toggle dropdown-company" data-toggle="dropdown">
      {{ selectedAccountCompany.commercial_name }}

      <span *ngIf="availableAccountCompanies.length > 0">
        <span *ngIf="selectedAccountCompany.is_default" title="{{ 'DEFAULT_DOMAIN' | translate }}">
          <i class="fa fa-star"></i>&nbsp;</span
        ><i class="fa fa-caret-down"></i>
      </span>
    </a>
    <ul class="dropdown-menu pull-right" *ngIf="availableAccountCompanies.length > 0">
      <li *ngFor="let company of availableAccountCompanies">
        <a class="cursor" (click)="switchAccountCompany(company)">
          {{ company.commercial_name }}
          <span *ngIf="company.is_default" title="{{ 'DEFAULT_COMPANY' | translate }}"
            ><i class="fa fa-star"></i
          ></span>
        </a>
      </li>
    </ul>
  `,
  standalone: true,
  imports: [SharedModule],
})
export class CompanySelectorComponent {
  availableAccountCompanies = [];
  selectedAccountCompany = null;

  private accountCompanies = [];

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) // @Inject('$location') private $location: any
  {
    this.accountCompanies = this.sessionService.getAccountCompanies();

    this.selectedAccountCompany = this.sessionService.getSelectedAccountCompany();
    this.setAvailableCompanies();
  }

  // // This is a subscription to an event emiter, (Angular way)
  // $scope.$on('reloadCompaniesSelector', reloadCompaniesSelector);

  // function reloadCompaniesSelector($event) {
  //   setAvailableCompanies();
  // }

  switchAccountCompany(company) {
    this.selectedAccountCompany = company;
    this.setAvailableCompanies();

    this.sessionService.setSelectedAccountCompany(company);

    this.router.navigate(['/']); // reload ??

    // this.$location.path('/'); // { reload: true } // Not working as it adds /#/
  }

  private setAvailableCompanies() {
    this.availableAccountCompanies = this.accountCompanies.filter(
      (company) => company.id !== this.selectedAccountCompany.id
    );
  }
}

// this.accountCompanies = this.sessionService.getAccountCompanies();

// ngOnInit(): void {} implements OnInit OnInit
